import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';
import { COOKIE_NAME } from './consts';
/*
 * Description
 * -------
 *
 * Removes password overlay on successful submit or if specific cookie is set.
 *
 * Can be used on any element.
 * Should be used only once in the document.
 *
 * Targets
 * -------
 *
 * input - (required) - input element
 * error - (required) - element with error message
 *
 * Values
 * -------
 *
 * password - (required) - password
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="wla-password"
 *   data-wla-password-password-value="password"
 * >
 *   <form data-action="submit->wla-password#validate">
 *     <input type="password" data-wla-password-target="input" />
 *     <p class="hidden" data-mobile-password-target="error">Incorrect password</p>
 *     <button type="submit">Enter</button>
 *   </form>
 * </div>
 */
export class WlaPassword extends Controller {
    static targets = ['input', 'error'];
    static values = { password: String };
    connect() {
        if (Cookies.get(COOKIE_NAME))
            this.element.remove();
    }
    validate(e) {
        e.preventDefault();
        if (e.target instanceof HTMLFormElement &&
            new FormData(e.target).get('password') === this.passwordValue) {
            this.element.remove();
            Cookies.set(COOKIE_NAME, 'true');
        }
        else {
            this.inputTarget.classList.add('error');
            this.errorTarget.classList.remove('hidden');
        }
    }
}
